import React from 'react';

class PhoneQuestion extends React.Component {
  constructor(props){
    super(props);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  onChangeHandler(e){
    const {value} = e.target;
    const {field} = this.props;

    //Cambiar estados
    this.props.handleChangeListener(field, value, null, null, null);
  }

  render() {
    const {field,text,note,predefinedValue,placeHolder, errors, isError} = this.props;
    const errorList = errors !== null? errors.map( (error) =>  <li key={error}>{error}</li>) : null

    return (
      <div className="pregunta">
          <div className="form-group">
              <label htmlFor={field}>{text}</label>
              <input 
                name={field} 
                type="number" 
                className="form-control"
                defaultValue={predefinedValue}
                placeholder={placeHolder}
                onChange={this.onChangeHandler}
                />
              <p className="question-subinstruction">{note}</p>
              {isError === true ? 
                <ul className="error">
                  {errorList}
                </ul>
                : null
              }        
          </div>
      </div>
    );
  }
}

export default PhoneQuestion;



// WEBPACK FOOTER //
// ./src/views/Forms/Patient/QuestionsTypes/PhoneQuestion.js